import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

const WHATSAPP_NUMBER = "2348154309694";
const PREFILL = "Hello Flames Nova, I need help with";

const HIDDEN_ROUTES = ["/auth", "/admin"];

const WhatsAppButton = () => {
  const { pathname } = useLocation();
  if (HIDDEN_ROUTES.some((r) => pathname.startsWith(r))) return null;

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILL)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Flames Nova on WhatsApp"
      className="fixed bottom-24 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full shadow-elevated transition-all hover:scale-110 active:scale-95 md:bottom-6"
      style={{ background: "linear-gradient(135deg, #25D366, #128C7E)" }}
    >
      <MessageCircle size={26} className="text-white" fill="white" strokeWidth={0} />
      <span className="pointer-events-none absolute inset-0 rounded-full animate-ping opacity-30" style={{ background: "#25D366" }} />
    </a>
  );
};

export default WhatsAppButton;
